import React, { useEffect, useState } from "react";
import AMap from "../../../../components/amap";
import MessageBox from "../../../../components/message-box";
import request from "../../../../network/request";
import { IReserveDetail } from "../../types";
import styles from "./index.module.scss";
import AmapMarker from "../components/AmapMarker";
import { reportUserBehavior } from "../../../../utils/common";
import useGetCh from "../../../../hooks/useGetCh";
import { handleSendToVehicle } from "../../../../utils/location";
import MapSwiper from "../components/MapSwiper";
import useQuery from "../../../../hooks/useQuery";
import { ErrorPlaceholder } from "../../../../components/placeholder";
import LoadingHomepage from "../../../maintence/components/LoadingHomepage";
import ServiceProgress from "./components/serviceProgress";
import { isXpAPP } from "../../../../utils/common";
import moment from "moment";
import { Link, useHistory, useLocation } from "react-router-dom";

interface IPosition {
  lng?: number | null;
  lat?: number | null;
  angle?: number | null;
}

const defaultDriverPosition = {
  lng: null,
  lat: null,
  angle: null
};

// 预约单详情
export default function ReserveDetail() {
  document.title = "预约详情";
  const query = useQuery();
  const reserveId = query.get("reserveId"); //预约单id（兼容旧的传参方式）
  const reserveOrderCode = query.get("reserveOrderCode"); //预约单号（包括取车和无取车）
  const ch = useGetCh();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [orderDetail, setOrderDetail] = useState<IReserveDetail | null>(null);
  const [mapIndex, setMapIndex] = useState(0);

  const [driverPosition, setDriverPosition] = useState<IPosition>(
    defaultDriverPosition
  );

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    history.listen((pre) => {
      console.log(location.pathname, pre.pathname, "路由变化");
      if (location.pathname !== pre.pathname) {
        MessageBox.removeAll();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (!loading && !error) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "reserve_detail",
          ch,
          pa: `status=success`
        },
        "page"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error]);

  const fetchReserveDetailData = async () => {
    try {
      const res: any = await request(
        "serviceOrder/getReserveDetail",
        {
          reserveUuid: reserveId || undefined,
          reserveOrderCode
        },
        "post"
      );
      setOrderDetail(res);
      if (res?.drivingDto?.isDisplayMap) {
        setDriverPosition({
          lng: res?.drivingDto?.curLng || null,
          lat: res?.drivingDto?.curLat || null,
          angle: res?.drivingDto?.angle || null
        });
      }
      window.scrollTo(0, 0);
      reportUserBehavior({
        so: "J001002",
        mcode: "reserve_detail__req_get_reserve_order_detail_success",
        ch,
        pa: `status=success\`reserveId=${reserveId}`
      });
    } catch (err) {
      reportUserBehavior({
        so: "J001002",
        mcode: "reserve_detail__req_get_reserve_order_detail_error",
        ch,
        pa: `status=error\`reserveId=${reserveId}`
      });
      setError(true);
      setErrorMsg((err as any).message || "获取预约订单失败，请稍后重试");
    }
  };

  useEffect(() => {
    getInitData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInitData = async () => {
    setLoading(true);
    setError(false);
    await fetchReserveDetailData();
    setLoading(false);
  };

  const handleCancel = () => {
    reportUserBehavior({
      so: "J001002",
      mcode: "reserve_order_detail__click_cancel",
      ch,
      pa: `reserveId=${reserveId}`
    });

    MessageBox.confirm("确定取消该预约吗？")
      .then(() => {
        console.log(
          "取消预约地址",
          "module/maintenance/reserve/cancel",
          orderDetail?.reserveUuid
        );
        console.log("reserveUuid", orderDetail?.reserveUuid);
        request("module/maintenance/reserve/cancel", {
          reserveUuid: orderDetail?.reserveUuid
        })
          .then((res: any): any => {
            MessageBox.toast("取消成功");
            reportUserBehavior({
              so: "J001002",
              mcode: "reserve_order_detail__req_cancel_success",
              ch,
              pa: `status=success\`reserveId=${reserveId}`
            });
            // 刷新数据
            getInitData();
          })
          .catch(() => {
            reportUserBehavior({
              so: "J001002",
              mcode: "reserve_order_detail__req_cancel_error",
              ch,
              pa: `status=success\`reserveId=${reserveId}`
            });
            MessageBox.toast("取消失败");
          });
      })
      .catch(() => {
        reportUserBehavior({
          so: "J001002",
          mcode: "reserve_order_detail__click_cancel_cancel",
          ch,
          pa: `reserveId=${reserveId}`
        });
        return null;
      });
  };

  // 地图信息
  const mapServiceInfo = (
    <div className={styles.mapWrapper}>
      <div className={`${styles.mapInfoContainer} swiper-no-swiping`}>
        <AMap>
          <AmapMarker
            isShopPosition={true}
            shopPosition={{
              lng: orderDetail?.shopAddress?.longitude || null,
              lat: orderDetail?.shopAddress?.latitude || null
            }}
            type={""}
          ></AmapMarker>
        </AMap>
      </div>
      <div className={styles.addressInfo}>
        <div className={styles.addressContainer}>
          <h3 className={styles.name}>{orderDetail?.shopAddress?.name}</h3>
          <p className={styles.address}>{orderDetail?.shopAddress?.address}</p>
          {isXpAPP() && (
            <div
              className={styles.send}
              onClick={() => {
                handleSendToVehicle(
                  orderDetail?.shopAddress?.latitude,
                  orderDetail?.shopAddress?.longitude,
                  orderDetail?.shopAddress?.name
                    ? orderDetail?.shopAddress?.name
                    : orderDetail?.shopAddress?.address,
                  orderDetail?.shopAddress?.address
                );
                reportUserBehavior({
                  so: "J001002",
                  mcode: "reserve_detail_click_handleSendToVehicle",
                  ch,
                  pa: `event=发送地址到车\`lat=${orderDetail?.shopAddress?.latitude}\`lng=${orderDetail?.shopAddress?.longitude}\`name=${orderDetail?.shopAddress?.name}\`address=${orderDetail?.shopAddress?.address}`
                });
              }}
            >
              <div className={styles.tip}>发送地址到车</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // 地图信息  drivingOrderType=1为取车
  const mapInfo =
    orderDetail?.drivingDto?.pickupLat && orderDetail?.drivingDto?.pickupLng ? (
      <div className={styles.swiperWrapper}>
        <h2>{mapIndex === 0 ? "取车地点" : "服务门店"}</h2>
        <MapSwiper
          onSlideDone={(index) => {
            setMapIndex(index);
          }}
        >
          <div className={styles.mapWrapper}>
            <div className={`${styles.mapInfoContainer} swiper-no-swiping`}>
              <AMap>
                <AmapMarker
                  isShopPosition={false}
                  driverPosition={driverPosition}
                  shopPosition={{
                    lng: orderDetail?.shopAddress?.longitude || null,
                    lat: orderDetail?.shopAddress?.latitude || null
                  }}
                  userPosition={
                    orderDetail?.drivingDto?.pickupLat &&
                    orderDetail?.drivingDto?.pickupLng
                      ? {
                          lng: orderDetail?.drivingDto?.pickupLng || null,
                          lat: orderDetail?.drivingDto?.pickupLat || null
                        }
                      : {}
                  }
                  type={
                    orderDetail?.drivingDto?.pickupLat &&
                    orderDetail?.drivingDto?.pickupLng
                      ? "pickup"
                      : ""
                  }
                ></AmapMarker>
              </AMap>
            </div>

            <div className={styles.addressInfo}>
              <div className={styles.addressContainer}>
                <h3 className={styles.name}>
                  {orderDetail?.pickupAddress.name}
                </h3>
                <p className={styles.address}>
                  {orderDetail?.pickupAddress.address}
                </p>
                {isXpAPP() && (
                  <div
                    className={styles.send}
                    onClick={() => {
                      handleSendToVehicle(
                        orderDetail?.drivingDto?.pickupLat,
                        orderDetail?.drivingDto?.pickupLng,
                        orderDetail?.drivingDto?.pickupAddress,
                        orderDetail?.drivingDto?.pickupAddress
                      );
                      reportUserBehavior({
                        so: "J001002",
                        mcode: "reserve_detail_click_handleSendToVehicle",
                        ch,
                        pa: `event=发送地址到车\`lat=${orderDetail?.drivingDto?.pickupLat}\`lng=${orderDetail?.drivingDto?.pickupLng}\`address=${orderDetail?.drivingDto?.pickupAddress}`
                      });
                    }}
                  >
                    <div className={styles.tip}>发送地址到车</div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>{mapServiceInfo}</div>
        </MapSwiper>
      </div>
    ) : (
      <div className={styles.swiperWrapper}>
        <h2>服务门店</h2>
        {mapServiceInfo}
      </div>
    );

  // 进度信息
  const progressInfo = orderDetail?.serviceProgress ? (
    <div className={styles.serviceProgressWrapper}>
      <h2>服务进度</h2>
      {orderDetail?.serviceProgress?.map((item, index) => {
        return (
          <ServiceProgress
            content={item}
            firstItem={index === 0}
            key={index}
            lastItem={index === orderDetail?.serviceProgress.length - 1}
          />
        );
      })}
    </div>
  ) : null;

  // 订单信息
  const orderInfo = (
    <div className={styles.orderInfoContainer}>
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>
          <h3>预约详情</h3>
        </div>
      </div>
      {/* 服务时间名称 */}
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>{orderDetail?.serviceTimeTitle}</div>
        <div className={styles.cellContent}>
          {moment(orderDetail?.serviceTime).format("YYYY/MM/DD HH:mm")}
        </div>
      </div>
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>预约车辆</div>
        <div className={styles.cellContent}>
          {orderDetail?.plateNumber
            ? orderDetail?.plateNumber
            : orderDetail?.vin}
        </div>
      </div>
      {orderDetail?.orderTypeText && (
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>服务项目</div>
          <div className={styles.cellContent}>{orderDetail?.orderTypeText}</div>
        </div>
      )}

      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.pickDriverName && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>司机姓名</div>
            <div className={styles.cellContent}>
              <span className={styles.pickDriverName}>
                {orderDetail?.drivingDto.pickDriverName}
              </span>
            </div>
          </div>
        )}
      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.pickDriverPhone && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>司机电话</div>
            <div className={styles.cellContent}>
              <a href={`tel:${orderDetail?.drivingDto?.pickDriverPhone}`}>
                {orderDetail?.drivingDto?.pickDriverPhone}
              </a>
            </div>
          </div>
        )}
      {orderDetail?.shopAddress?.telephone && (
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>门店电话</div>
          <div className={styles.cellContent}>
            <a href={`tel:${orderDetail?.shopAddress?.telephone}`}>
              {orderDetail?.shopAddress?.telephone}
            </a>
          </div>
        </div>
      )}

      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.verifyCode && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>取车验证码</div>
            <div className={styles.cellContent}>
              <span className={styles.verifyCode}>
                {orderDetail?.drivingDto.verifyCode}
              </span>
            </div>
          </div>
        )}
      {orderDetail?.drivingDto?.drivingOrderType === 1 &&
        orderDetail?.drivingDto?.pickupPhotoList &&
        orderDetail?.drivingDto?.pickupPhotoList.length > 0 && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>取车照片</div>
            <div className={styles.cellContent}>
              <Link
                to={{
                  pathname: "/serviceOrders/preview",
                  state: {
                    imgList: orderDetail?.drivingDto?.pickupPhotoList,
                    title: "取车照片"
                  }
                }}
              >
                <button
                  className={styles.pictureViewBtn}
                  onClick={() => {
                    reportUserBehavior({
                      so: "J001005",
                      mcode: "reserve_detail__click_pick_preview",
                      ch,
                      pa: ""
                    });
                  }}
                >
                  查看
                </button>
              </Link>
            </div>
          </div>
        )}
    </div>
  );

  const cancelOpt = orderDetail?.allowCancel ? (
    <div className={styles.scheduleCancelContainer}>
      <div className={styles.scheduleOpt}>
        <button className={styles.cancelScheduleBtn} onClick={handleCancel}>
          取消预约
        </button>
      </div>
    </div>
  ) : null;

  if (loading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (error) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "reserve_detail",
        ch,
        pa: `status=error`
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={getInitData}
      ></ErrorPlaceholder>
    );
  }

  return (
    <div className={styles.detailPageWrapper}>
      {mapInfo}
      {orderInfo}
      {progressInfo}
      {cancelOpt}
    </div>
  );
}
